import { motion } from "framer-motion";
import { ArrowUpRight, Check } from "lucide-react";
import { useApp } from "../context/AppContext";
import { IMAGES } from "../lib/site";
import { Reveal, SectionHead } from "./Reveal";

const FLEET_IMAGES = { bigbus: IMAGES.bigBus, mediumbus: IMAGES.mediumBus, hiace: IMAGES.hiace };

export const Fleet = () => {
  const { t, waLink } = useApp();
  return (
    <section id="armada" className="mx-auto max-w-7xl px-6 py-24 md:px-10 md:py-36" data-testid="fleet-section">
      <SectionHead overline={t.fleet.overline} title={t.fleet.title} sub={t.fleet.sub} testId="fleet-head" />

      <div className="mt-20 space-y-24 md:mt-28 md:space-y-32">
        {t.fleet.items.map((item, i) => {
          const flip = i % 2 === 1;
          return (
            <div key={item.key} className="grid items-center gap-8 md:grid-cols-12" data-testid={`fleet-card-${item.key}`}>
              <div className={`md:col-span-7 ${flip ? "md:order-2" : ""}`}>
                <motion.div
                  initial={{ clipPath: "inset(0 100% 0 0)" }}
                  whileInView={{ clipPath: "inset(0 0% 0 0)" }}
                  viewport={{ once: true, margin: "-100px" }}
                  transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                  className="overflow-hidden rounded-2xl"
                >
                  <motion.img
                    src={FLEET_IMAGES[item.key]}
                    alt={item.name}
                    initial={{ scale: 1.15 }}
                    whileInView={{ scale: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
                    className="max-h-[80vh] w-full object-cover md:h-[480px]"
                  />
                </motion.div>
              </div>

              <Reveal className={`relative z-10 md:col-span-5 ${flip ? "md:order-1 md:-mr-14" : "md:-ml-14"}`} delay={0.15}>
                <div className="rounded-2xl border border-border bg-card p-8 shadow-xl md:p-10">
                  <p className="font-display text-sm font-bold tracking-[0.3em] text-primary">0{i + 1}</p>
                  <div className="mt-4 flex flex-wrap items-baseline gap-x-4 gap-y-2">
                    <h3 className="font-display text-3xl font-semibold tracking-tight md:text-4xl">{item.name}</h3>
                    <span className="rounded-full bg-primary/10 px-3 py-1 text-xs font-bold uppercase tracking-wider text-primary">{item.seats}</span>
                  </div>
                  <p className="mt-4 leading-relaxed text-muted-foreground">{item.desc}</p>
                  <ul className="mt-6 grid grid-cols-1 gap-2.5 sm:grid-cols-2">
                    {item.features.map((f) => (
                      <li key={f} className="flex items-center gap-2 text-sm font-medium">
                        <Check className="h-4 w-4 shrink-0 text-primary" />
                        {f}
                      </li>
                    ))}
                  </ul>
                  <a
                    href={waLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`fleet-cta-${item.key}`}
                    className="mt-8 inline-flex items-center gap-2 font-display text-sm font-bold text-primary transition-colors duration-200 hover:opacity-75"
                  >
                    {t.fleet.cta}
                    <ArrowUpRight className="h-4 w-4" />
                  </a>
                </div>
              </Reveal>
            </div>
          );
        })}
      </div>
    </section>
  );
};
